import { ReactElement, useMemo, useState, useCallback } from 'react';
import MessagePrompt from 'common/components/messagePrompt';
import useAnalytics from 'common/utils/hooks/useAnalytics';
import { TRACK_EVENTS } from 'constants/trackEvents';
import { ReactComponent as AlertIcon } from 'images/icons/alertIcon.svg';
import { StyledPromptText, DontShowMeAgainWrapper } from './style';
import useTexts from './hooks/useTexts';

type DontShowMeAgainPromptProps = {
  showPrompt: boolean;
  handleClosePrompt: () => void;
  onOkClick: (isDontShowMeAgain: boolean) => void;
  mergeBtnStyle: React.CSSProperties | null;
  btnOkText: string | ReactElement;
  isMergeLoading: boolean;
};

const DontShowMeAgainPrompt = ({
  showPrompt,
  handleClosePrompt,
  onOkClick,
  mergeBtnStyle,
  btnOkText,
  isMergeLoading,
}: DontShowMeAgainPromptProps): ReactElement | null => {
  const [isDontShowMeAgain, setIsDontShowMeAgain] = useState(false);
  const trackEvents = useAnalytics();

  const { mergeWarningTitle, mergeTicketsAnnotation, dontShowMeAgain } = useTexts();

  const handleCheckboxClick = useCallback(async () => {
    if (!isDontShowMeAgain) {
      trackEvents(TRACK_EVENTS.CHECK_IN_MERGE_CONFIRMATION_POPUP);
    }
    setIsDontShowMeAgain(!isDontShowMeAgain);
  }, [setIsDontShowMeAgain, trackEvents, isDontShowMeAgain]);

  const dontShowMeAgainAnnotation = useMemo(
    () => (
      <DontShowMeAgainWrapper>
        <input
          type="checkbox"
          checked={isDontShowMeAgain}
          onClick={handleCheckboxClick}
          disabled={isMergeLoading}
          id="dont-show-me-again"
        />
        {dontShowMeAgain}
      </DontShowMeAgainWrapper>
    ),
    [isDontShowMeAgain, dontShowMeAgain, handleCheckboxClick, isMergeLoading],
  );

  const handleOkClick = useCallback(() => {
    onOkClick(isDontShowMeAgain);
  }, [onOkClick, isDontShowMeAgain]);

  return showPrompt ? (
    // @ts-ignore
    <MessagePrompt
      title={mergeWarningTitle}
      showCancelBtn
      isFitContent
      Icon={AlertIcon}
      btnOkText={btnOkText}
      okBtnStyles={mergeBtnStyle}
      open={showPrompt}
      customAnnotation={dontShowMeAgainAnnotation}
      onClose={handleClosePrompt}
      onOkClick={handleOkClick}
      isOkButtonDisable={isMergeLoading}
      isCancelButtonDisable={isMergeLoading}
    >
      <StyledPromptText>{mergeTicketsAnnotation}</StyledPromptText>
    </MessagePrompt>
  ) : null;
};

export default DontShowMeAgainPrompt;
